"use client"

import type { ComponentProps } from "react"
import { useEnsureRoom, useStartAudio } from "../react"
import { Button } from "@workspace/ui/components/button"
import type { Room } from "../client"

export interface StartAudioButtonProps extends ComponentProps<"button"> {
  size?: "default" | "sm" | "lg" | "icon" | "icon-sm" | "icon-lg"
  variant?:
    | "default"
    | "destructive"
    | "outline"
    | "secondary"
    | "ghost"
    | "link"
  room?: Room
  label: string
}

export function StartAudioButton({
  size = "default",
  variant = "default",
  label,
  room,
  ...props
}: StartAudioButtonProps) {
  const roomEnsured = useEnsureRoom(room)
  const { mergedProps } = useStartAudio({ room: roomEnsured, props })
  return (
    <Button size={size} variant={variant} {...props} {...mergedProps}>
      {label}
    </Button>
  )
}
